import {Modal, Stack, Box} from "@mui/material";
import {ModalType, SponsorType} from "data/enums";
import {useViewController} from "data/services/locator/locator_hook.service";
import {includes, isEqual} from "lodash";
import {observer} from "mobx-react";
import React from "react";
import {
	ModalBox,
	ModalContentCustom,
	ModalHeader,
} from "views/components/modals/modal_common.component";
import {IModalsController} from "views/controllers/modals/modals.controller";
import {Bindings} from "data/constants/bindings";
import {SecondRegistrationFormComponent} from "views/components/forms/second_registration_form/second_registration_form";
import {useLocation} from "react-router";
import styled from "@emotion/styled";
import {TEAM_DATA} from "data/constants";
import {SponsorLogo} from "views/components/sponsor_logo/sponsor_logo.component";
import {Exist} from "views/components/exist/exist.component";

const Logo = styled.div`
	max-width: 125px;

	img {
		width: 100%;
	}
`;

const ModalHeaderStyled = styled(ModalHeader)`
	display: flex;
	flex-flow: column;
	gap: 10px;
`;

const Container = styled(Box)`
	max-width: 320px;
	margin: 0 auto;
`;

export const ModalSecondRegistration: React.FC = observer(() => {
	const controller = useViewController<IModalsController>(Bindings.ModalsController);
	const {visibleModal} = controller;
	const location = useLocation();
	const isVisible =
		isEqual(visibleModal, ModalType.SECOND_REGISTRATION) &&
		!includes(location.pathname, "help");

	if (!isVisible) {
		return null;
	}

	return (
		<Modal open={isVisible}>
			<ModalBox>
				<ModalHeaderStyled>
					<Logo>
						<img src={TEAM_DATA.logo} alt={"CFL"} />
					</Logo>
					<Exist when={TEAM_DATA.sponsorData?.sponsorLogoAltRegistrationEnabled}>
						<SponsorLogo type={SponsorType.LOGO_ALT} width="112px" height="40px" />
					</Exist>
				</ModalHeaderStyled>
				<ModalContentCustom>
					<Container>
						<Stack alignItems={"center"}>
							<SecondRegistrationFormComponent />
						</Stack>
					</Container>
				</ModalContentCustom>
			</ModalBox>
		</Modal>
	);
});
